module.exports = __webpack_public_path__ + "img/m8.98260150.jpg";